wbApp.controller('RentCategoriesCtrl', ['$scope', '$modal', '$translate', '$timeout', '$q', 'rentCategorySvc', 'rentCategoryGroupSvc',
function ($scope, $modal, $translate, $timeout, $q, rentCategorySvc, rentCategoryGroupSvc) {

    function refreshData(reselect)
    {
        return $q(function (resolve, reject) {
            var selectedRowKeys = null;
            if (!!$scope.gridSettings && !!$scope.gridSettings.gridInstance && !!reselect) {
                selectedRowKeys = $scope.gridSettings.gridInstance.getSelectedRowKeys();
            }

            var all = rentCategorySvc.getAll(true);
            all.$promise.then(function (data) {
                $scope.rentCategories = data;

                if (!!selectedRowKeys && !!$scope.gridSettings && !!$scope.gridSettings.gridInstance && !!reselect) {
                    $timeout(function () {
                        $scope.gridSettings.gridInstance.selectRows(selectedRowKeys, false).then(function (rows) {
                            if (!rows || !rows.length) {
                                setSelectedRentCategory(null);
                            }
                        })
                    }, 100);
                }
                else {
                    setSelectedRentCategory(null);
                }

                resolve();

            }, function (error) {
                $scope.rentCategories = [];
                setSelectedRentCategory(null);

                reject();
            });
        });
    }

    refreshData();

    var rentCategoryGroupDataSource = new DevExpress.data.CustomStore({
        load: function (loadOptions) {
            return rentCategoryGroupSvc.getAll().$promise;
        },
        byKey: function (e) {
            return rentCategoryGroupSvc.getById(e);
        },
        loadMode: 'processed'
    });

    $scope.$on('refreshData', function (e, data) {
        refreshData(true);
    });

    $scope.gridSettings = {
        name: 'rentCategories',
        keyExpr: 'id',
        columns: [
            { dataField: 'id', caption: $translate.instant('TXT_LBL_ID'), dataType: 'string', visible: false },
            { dataField: 'isActive', caption: $translate.instant('TXT_LBL_ACTIVE'), dataType: 'boolean', width: '60px' },
            { dataField: 'name', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string', width: '160px', sortOrder: 'asc' },
            { dataField: 'shortDescription', caption: $translate.instant('TXT_LBL_SHORT_DESCRIPTION'), dataType: 'string' },
            {
                dataField: 'rentCategoryGroupId',
                caption: $translate.instant('TXT_MENU_RENT_CATEGORY_GROUP'),
                dataType: 'string',
                width: '150px',
                visible: true,
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: rentCategoryGroupDataSource,
                        pageSize: 20,
                        paginate: true
                    },
                    valueExpr: 'id', // contains the same values as the "statusId" field provides
                    displayExpr: 'name' // provides display values
                },
            },
            {
                dataField: 'itemSelectionType',
                caption: $translate.instant('TXT_LBL_ITEM_SELECTION_TYPE'),
                dataType: 'string',
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: {
                            type: 'array',
                            data: [
                                { id: 0, name: $translate.instant('TXT_ITEM_SELECTION_TYPE_MANUAL') },
                                { id: 1, name: $translate.instant('TXT_ITEM_SELECTION_TYPE_AUTOMATIC') }
                            ],
                            key: "id"
                        },
                        pageSize: 10,
                        paginate: false
                    },
                    valueExpr: 'id', // contains the same values as the "statusId" field provides
                    displayExpr: 'name' // provides display values
                },
                width: '150px'
            },
            {
                dataField: 'rentingPeriodType',
                caption: $translate.instant('TXT_RENTING_PERIOD_TYPE'),
                dataType: 'string',
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: {
                            type: 'array',
                            data: [
                                { id: 0, name: $translate.instant('TXT_RENTING_PERIOD_TYPE_MINUTES') },
                                { id: 1, name: $translate.instant('TXT_RENTING_PERIOD_TYPE_WHOLE_CALLENDAR_DAYS') }
                            ],
                            key: "id"
                        },
                        pageSize: 10,
                        paginate: false
                    },
                    valueExpr: 'id', // contains the same values as the "statusId" field provides
                    displayExpr: 'name' // provides display values
                },
                width: '150px'
            },
        ]
    }


    $scope.onRowSelected = function (data) {
        setSelectedRentCategory(data);
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = rentCategorySvc.createNew();
            detailDialogPromise.$scope.onRentCategorySave = function (model) {
                refreshData().then(function() {
                    if (!!$scope.gridSettings && !!$scope.gridSettings.gridInstance) {
                        $timeout(function () {
                            $scope.gridSettings.gridInstance.selectRows([model.id], false).then(function (rows) {
                                if (!rows || !rows.length) {
                                    setSelectedRentCategory(null);
                                }
                            });
                        }, 100);
                    }
                });
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.$scope.onRentCategorySave = function () {
                refreshData(true);
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowCopy = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.$scope.model.isNew = true;
            detailDialogPromise.$scope.model.id = null;
            detailDialogPromise.$scope.onRentCategorySave = function (model) {
                refreshData().then(function () {
                    if (!!$scope.gridSettings && !!$scope.gridSettings.gridInstance) {
                        $timeout(function () {
                            $scope.gridSettings.gridInstance.selectRows([model.id], false).then(function (rows) {
                                if (!rows || !rows.length) {
                                    setSelectedRentCategory(null);
                                }
                            });
                        }, 100);
                    }
                });
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        rentCategorySvc.remove(data.id).$promise.then(function () {
            refreshData();
        });
    }

    function setSelectedRentCategory(rentCategory, refresh) {
        $scope.selectedRentCategory = rentCategory;
        $scope.$broadcast('rentCategorySelectionChanged', $scope.selectedRentCategory);
    }


    var detailDialogPromise = $modal({
        templateUrl: 'rents/rent-category/rent-category-detail.html',
        show: false,
        scope: $scope.$new()
    });


}]);
